import { type MantineSize } from '@mantine/core';
import { ImageInput } from '../../inputs/ImageInput';
import { useEditorContext } from '../EditorContext';
import type { LooseKeys } from '../types';
import { ModalEditorItemBase } from './ModalEditorItemBase';

export interface ModalImageItemProps<TFormType> {
    fieldKey?: LooseKeys<TFormType>;
    imageUrl?: string;
    onChange: (file: File | null) => void;
    required?: boolean;
    size?: MantineSize;
    radius?: number | string;
    label?: string;
    labelWidth?: number;
}

export const ModalImageItem = <TFormType,>({
    fieldKey,
    imageUrl,
    onChange,
    required,
    label,
    labelWidth,
    ...imageInputProps
}: ModalImageItemProps<TFormType>) => {
    const { form, loading } = useEditorContext<TFormType>();

    const error = fieldKey ? form.errors[fieldKey as string] : undefined;

    return (
        <ModalEditorItemBase label={label} labelWidth={labelWidth} error={error} required={required}>
            <ImageInput disabled={loading} imageUrl={imageUrl} onChange={onChange} {...imageInputProps} />
        </ModalEditorItemBase>
    );
};
